<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="this.btnSelectReadColor" v-if="result.basic.act === false">
        toggle_on
      </v-icon>
      <v-icon :color="this.btnSelectReadColor" v-else>
        toggle_on
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <span :class="ui.textTitle">
              {{item.title}}
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              {{displayDocumentIDGTypeA(this.result.basic.tag, this.result.basic.idg)}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{item.icon}}</v-icon>
                </v-avatar>
                {{item.heading}}
              </v-chip>
            </span>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBoldWarning"
            class="hidden-xs-only"
            v-if="this.getUser.basic.admin === true">
              Admin
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            class="hidden-xs-only">
              {{defineStatus}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
            v-if="this.result.basic.lock === false">
              <v-avatar>
                <v-icon>key</v-icon>
              </v-avatar>
              {{item.auth}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
            v-else>
              <v-avatar>
                <v-icon>lock</v-icon>
              </v-avatar>
              {{item.auth}}
            </v-chip>
          </v-layout>
          <v-container class="ml-3" v-if="this.tag === 'X1'">
            <v-layout row class="ml-2">
              <v-flex xs12>
                <v-icon :color="ui.btnColor"> schedule </v-icon>
                <a :class="ui.textDescription">  {{ dateTypeB(dateTime) }} - </a>
                <a :class="ui.textDescription"> {{ dateTimeAgo(dateTime) }} ago </a>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container class="ml-3"
          v-if="this.tag === 'G1' || this.tag === 'C1'">
            <v-layout class="ml-3 mr-3 mt-1">
              <div :class="ui.textSubheadingGrey">
                {{item.describe}}
              </div>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- {{this.result.trans.stat}} -->
        <v-card-actions>
          <v-btn class="hidden-sm-and-up"
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon> exit_to_app </v-icon>
          </v-btn>
          <v-btn class="hidden-xs-only"
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            {{item.btnCloseTitle}}
          </v-btn>
          <v-spacer/>
          <GetDetailPage
          v-if="
          this.level !== 1 &&
          this.result.trans.stat.lock === false &&
          this.item.enableDetail
          "
          :data="{
            tag: 'C1',
            size: 'flat',
            item: this.result}"
          />
          <GetDetailPage
          v-if="this.enableAccessAuthEdit('G1')"
          :data="{
            tag: 'G1',
            size: 'flat',
            item: this.result}"
          />
          <div class="hidden-xs-only">
            <div v-if="!this.enableSpinBtnAccessSelect">
              <v-btn
              v-if="this.selectEnable"
              @click="selectItem(result)" :color="ui.btnColor" flat>
                <v-icon left> toggle_on </v-icon>
                Select
              </v-btn>
            </div>
            <div v-else>
              <BtnSpin :btnSpec="btnInfo1"/>
            </div>
          </div>
          <div class="hidden-sm-and-up">
            <div v-if="!this.enableSpinBtnAccessSelect">
              <v-btn
              v-if="this.selectEnable"
              @click="selectItem(result)" :color="ui.btnColor" flat>
                <v-icon> toggle_on </v-icon>
              </v-btn>
            </div>
            <div v-else>
              <BtnSpin :btnSpec="btnInfo1"/>
            </div>
          </div>
          <v-btn v-if="!this.selectEnable" :color="ui.bkgdColor" icon
          class="hidden-sm-and-up">
            <v-icon :color="ui.btnColorWarning"> lock </v-icon>
          </v-btn>
          <v-btn v-if="!this.selectEnable" :color="ui.btnColorWarning" flat
          class="hidden-xs-only">
            <v-icon left> lock </v-icon>
            Select
          </v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import selectFunctions from "@/support/access/mixins/selectFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import iconFunctions from "@/data/functions/mixins/iconFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import describeAccess from "@/data/describe/mixins/describeAccess";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  mixins: [
    apptheme,
    selectFunctions,
    getData,
    iconFunctions,
    numberFunctions,
    dateFunctions,
    describeDocument,
    describeAccess,
    displayFunctions,
    accessFunctions
  ],
  components: {
    GetDetailPage,
    BtnSpin
  },
  data() {
    return {
      dialog: false,
      valid: false,
      btnSpinReadResult: false,
      enableSpinBtnAccessSelect: false,
      indeterminateProgressBar: false,
      statusBarSupComponentsSettings: {
        type: "std",
        size: "med",
        chipColor: "wplgrey0",
        textColor: "wplblue1"
      },
      transionsStatusSettings: {
        type: "std",
        size: "med",
        chipColor: "wplgrey0",
        textColor: "wplblue1"
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDataSource",
      "getSearchResults",
      "getPageTitle",
      "getUser"
    ]),
    selectEnable() {
      // you can only select access if you are user U1
      let logic = false;
      if (this.item.auth === 0 && this.item.heading === "Facility Founder") {
        logic = true;
      } else if (
        this.level !== 1 &&
        this.result.trans.stat.lock === false &&
        this.result.basic.tagd === "U1" &&
        this.result.basic.lock === false &&
        this.item.enableSelect
      ) {
        logic = true;
      } else if (
        this.getUser === undefined &&
        this.getUser.basic.admin === true &&
        this.result.basic.tagd === "U1" &&
        this.result.basic.lock === false
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    btnSelectReadColor() {
      let color = null;
      let status = this.result.basic.list;
      if (status !== undefined && status !== null) {
        if (status === true) {
          color = this.ui.btnColorWarning;
        } else {
          color = this.ui.btnColor;
        }
      } else {
        color = this.ui.btnColor;
      }
      return color;
    },
    result() {
      return this.getSearchResults[this.listIndex];
    },
    tag() {
      let tag = this.result.basic.tag;
      if (tag === "G1") {
        if (this.result.basic.tags === "C1") {
          tag = "C1";
        } else {
          tag = this.result.basic.tag;
        }
      } else {
        tag = this.result.basic.tag;
      }
      return tag;
    },
    defineStatus() {
      let status = null;
      let trans = this.result.trans;
      if (this.result.basic.lock === true) {
        status = "Locked";
      } else {
        status = trans.hist[trans.hist.length - 1].title;
      }
      return status;
    },
    level() {
      let level = this.result.trans.level;
      return level;
    },
    item() {
      let obj = {
        tag: "",
        auth: "",
        title: "",
        heading: "",
        describe: "",
        btnCloseTitle: "",
        enableSelect: true,
        enableDetail: true,
        icon: ""
      };
      let tag = this.result.basic.tag;
      let tagd = this.result.basic.tagd;
      let tags = this.result.basic.tags;
      // let name = null;
      if (tag === "G1" && tagd === "C1" && tags === "U1") {
        obj.tag = "U1";
        obj.auth = this.result.select.cauth;
        obj.title = this.result.char.utitle;
        obj.auth = this.result.select.cauth;
        if (obj.auth === null) {
          obj.icon = "account_balance";
          obj.describe = "Admin to define access level.";
          obj.heading = "Company Access Undefined";
        } else {
          obj.icon = this.defineAccess(tagd, obj.auth).icons;
          obj.describe = this.defineAccess(tagd, obj.auth).des;
          obj.heading = this.defineAccess(tagd, obj.auth).title;
        }
        obj.enableSelect = false;
        obj.enableDetail = false;
        obj.btnCloseTitle = "close";
      } else if (tag === "G1" && tagd === "U1" && tags === "C1") {
        obj.tag = "U1";
        obj.auth = this.result.select.cauth;
        obj.title = this.result.char.title;
        obj.auth = this.result.select.cauth;
        if (obj.auth === null) {
          obj.icon = "account_balance";
          obj.describe = "Admin to define access level.";
          obj.heading = "Company Access Undefined";
        } else {
          obj.icon = this.defineAccess(tags, obj.auth).icons;
          obj.describe = this.defineAccess(tags, obj.auth).des;
          obj.heading = this.defineAccess(tags, obj.auth).title;
        }
        obj.enableSelect = true;
        obj.enableDetail = false;
        obj.btnCloseTitle = "close";
      } else if (tag === "G1" && tagd === "F1" && tags === "U1") {
        obj.tag = "F1";
        obj.title = this.result.char.utitle;
        obj.auth = this.result.select.fauth;
        obj.btnCloseTitle = "close";
        obj.enableDetail = false;
        obj.enableSelect = false;
        if (obj.auth === null) {
          obj.icon = "place";
          obj.describe = "Admin to define access level.";
          obj.heading = "Facility Access Undefined";
        } else {
          obj.icon = this.defineAccess("F1", obj.auth).icons;
          obj.describe = this.defineAccess("F1", obj.auth).des;
          obj.heading = this.defineAccess("F1", obj.auth).title;
        }
      } else if (tag === "G1" && tagd === "U1" && tags === "F1") {
        obj.tag = "U1";
        obj.title = this.result.char.title;
        obj.auth = this.result.select.fauth;
        if (obj.auth === null) {
          obj.icon = "place";
          obj.describe = "Admin to define access level.";
          obj.heading = "Facility Access Undefined";
        } else {
          obj.icon = this.defineAccess("F1", obj.auth).icons;
          obj.describe = this.defineAccess("F1", obj.auth).des;
          obj.heading = this.defineAccess("F1", obj.auth).title;
        }
        obj.enableSelect = true;
        obj.enableDetail = false;
        obj.btnCloseTitle = "close";
      } else if (tag === "G1" && tagd === "Z5" && tags === "C1") {
        obj.tag = "C1";
        obj.title = this.result.char.title;
        obj.auth = this.result.select.cauth;
        obj.btnCloseTitle = "close";
        obj.enableDetail = false;
        obj.icon = this.defineAccess("C1", obj.auth).icons;
        obj.describe = this.defineAccess("C1", obj.auth).des;
        obj.heading = this.defineAccess("C1", obj.auth).title;
      } else {
        obj.tag = "U1";
        obj.title = "User";
        obj.icon = "person";
        obj.enableSelect = false;
        obj.enableDetail = false;
        obj.heading = this.result.char.utitle;
        obj.auth = this.result.select.cauth;
      }
      // others
      return obj;
    }
  },
  // eslint-disable-next-line
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    selectItem(result) {
      this.enableSpinBtnAccessSelect = true;
      this.selectAccess(result);
      // SNACK BAR
      let msg = "";
      msg = msg + this.defineDocumentFromTag(result.char.tag).title;
      msg = msg + " " + result.char.title;
      msg = msg + " was selected.";
      this.generateInfoSnackbar(this.ui.colorBlue1, msg);
    },
    openDialog() {
      this.dialog = true;
      this.btnSpinReadResult = false;
      this.resetStore();
      this.$store.dispatch("changeDataSavePendingIndication", false);
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    }
  }
};
</script>
